import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { apiService } from '../../../services/apiService';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-phone-number-input/style.css'
function VendorCompanyEdit() {
    
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        company_name: '',
        email_domain: '',
        company_url: '',
    });
    const [errors, setErrors] = useState({});
    const [btnloading, setBtnLoading] = useState(false);
    const [errorsmessage, setErrorMessage] = useState('');
    

    const fetchRecruiterData = useCallback(async () => {
        try {
            const response = await apiService.getRequest(`/c2c/companies/${id}`);
            const Recruiter = response?.data;
            setFormData({
                company_name: Recruiter?.company?.company_name || '',
                email_domain: Recruiter?.company?.email_domain || '',
                company_url: Recruiter?.company?.company_url || '',
                
            });
        } catch (error) {
            
        }finally {
            setLoading(false);
        }
    }, [id]);
    useEffect(() => {
        fetchRecruiterData();
    }, [fetchRecruiterData]);

    // Clear specific errors when inputs are modified
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Clear the error for the changed field
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };
    

    // Basic validation logic
    const validate = () => {
        const newErrors = {};
        if (!formData.company_name) newErrors.company_name = 'Name is required';
        if (!formData.email_domain) {
            newErrors.email_domain = 'Email domain is required';
        } else {
            const email_domain = formData.email_domain;
            const domainFormat = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            if (!domainFormat.test(email_domain)) {
                newErrors.email_domain = 'Please enter a valid domain (e.g. example.com)';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        const data = new FormData();
        data.append('company_name', formData.company_name);
        data.append('email_domain', formData.email_domain);
        data.append('company_url', formData.company_url);

        setBtnLoading(true);
        try {
            const response = await apiService.postRequest(`/c2c/companies/${id}`, data);
            if (response && response.success === true) {
                navigate(`/recruiter/vendor-company/view/${id}`)
                toast(response.message || "Created successfully!");
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            // console.error('Error', error);
        } finally {
            setBtnLoading(false);
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container justifyContent="center" className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>C2C</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/recruiter/vendor-company")}>C2C</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/recruiter/vendor-company")}>Vendor Company</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Edit Company</span>
                    </Grid>
                    <Grid size={{xs:12}} container className="editgrouphead my-4">
                        <h2>Edit Company</h2>
                    </Grid>
                </Grid>
                {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    <form className='row justify-content-center w-100'>
                        <Grid size={{sm:11,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Company Name<small className='red_starimpo'>*</small></span>
                                <input type="text" name="company_name" placeholder='Enter Company Name' value={formData.company_name} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}/>
                                {errors.company_name && <p style={{color:"red"}}>{errors.company_name}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Email Domain<small className='red_starimpo'>*</small></span>
                                <input type="text" placeholder='example@gmail.com' name="email_domain" value={formData.email_domain} onChange={handleInputChange}/>
                                {errors.email_domain && <p style={{color:"red"}}>{errors.email_domain}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Company URL</span>
                                <input type="url" placeholder='https://www.example.com' name="company_url" value={formData.company_url} onChange={handleInputChange}/>
                                {errors.company_url && <p style={{color:"red"}}>{errors.company_url}</p>}
                            </Grid>
                        {errorsmessage && <p style={{ color: 'red', width:"100%" }}>{errorsmessage}</p>}
                        </Grid>
                        <Grid size={{sm:11,xs:12}} container justifyContent="flex-end" className="gap-3 my-3">
                            <button type="button" className='registersendbtn1 my-0' onClick={()=>navigate(`/recruiter/vendor-company/view/${id}`)}>Cancel</button>
                            <button type="button" onClick={handleSubmit} className='registersendbtn2 my-0 px-3'>{btnloading ? <img src={require('../../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                        </Grid>
                    </form>
                </>}
            </Grid>
        </div>
    </div>
  )
}

export default VendorCompanyEdit
